// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__xvcPw","footer_text":"footer_footer_text__7V6lb","footer_link":"footer_footer_link__xfjH5"};